import { gql } from "graphql-request";

export const OperationErrorsFragment = gql`
  fragment OperationErrorsFragment on OperationInfo {
    messages {
      message
      code
      kind
      field
    }
  }
`;
